import {
    type IncomeSplitConfig,
    IncomeSplitConfigCreatedVia,
    PaycheckRoutingStatus,
} from '@fruitful/income-split';
import { type MoneyMap, MoneyMapStatus } from '@fruitful/types';

export const getCurrentIncomeSplitConfig = (
    incomeSplitConfigs: IncomeSplitConfig[],
): IncomeSplitConfig | undefined =>
    incomeSplitConfigs.find(
        (config) => config.status === PaycheckRoutingStatus.ACTIVE,
    ) ??
    incomeSplitConfigs.find(
        (config) => config.status !== PaycheckRoutingStatus.DELETED,
    );

/**
 * Money map id for the membership's live split when that split is ACTIVE or
 * INACTIVE (shown on the Money System tab). Null when there is no such source
 * (e.g. DELETED split) so the archived map can appear in Previous Money Maps.
 */
export const getLiveSplitSourceMoneyMapId = (
    currentIncomeSplit: {
        moneyMapId: string | null;
        status: string;
    } | null,
): string | null => {
    if (
        currentIncomeSplit == null ||
        (currentIncomeSplit.status !== PaycheckRoutingStatus.ACTIVE &&
            currentIncomeSplit.status !== PaycheckRoutingStatus.INACTIVE)
    ) {
        return null;
    }
    return currentIncomeSplit.moneyMapId;
};

export const canMemberEditMoneyMap = (
    moneyMap: Pick<MoneyMap, 'id' | 'status' | 'eligibleForMemberEdit'>,
    currentIncomeSplit: Pick<
        IncomeSplitConfig,
        'moneyMapId' | 'createdVia'
    > | null,
): boolean => {
    if (moneyMap.eligibleForMemberEdit !== true) {
        return false;
    }

    if (
        moneyMap.status !== MoneyMapStatus.ACTIVE &&
        moneyMap.status !== MoneyMapStatus.INACTIVE
    ) {
        return false;
    }

    return (
        currentIncomeSplit?.moneyMapId === moneyMap.id &&
        currentIncomeSplit.createdVia !==
            IncomeSplitConfigCreatedVia.INCOME_SPLIT_EDITOR
    );
};
